angular.module('natgeo').controller('Level1RewardScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'Printer', 'ScreenView', 'UserProgress', 'SoundEngine',
function Level1RewardScreen($scope, element, ScreenFactory, manager, container, Printer, ScreenView, UserProgress, SoundEngine)
{
	var screen = ScreenFactory( 'level1_reward', element );

	screen.once('introBefore', function()
	{
		anim8.save('newspaper', {
			keyframe: {
				'0': {
					scale: 0,
					opacity: 0,
					translateX: 50,
					rotate: 360 * 2
				},
				'20': {
					opacity: 1
				},
				'100': {
					scale: 1,
					translateX: 0,
					rotate: 0
				}
			},
			units: {
				translateX: '%'
			}
		});
		
	});

	// Level completed!
	screen.on('introBefore', function()
	{
		UserProgress.Level1 = 1;
		UserProgress.savePasscode();

		SoundEngine.play( 'goal-achieved' );
	});
	
	// Print the reward
	$scope.print = function()
	{
		Printer( 'level1/images/roboworksIDprint.pdf' );
	};

	// The next screen is the office screen
	$scope.next = function()
	{
		ScreenView.change('splash', 'splash_menu', true, undefined, 'loading_menu');
	};
	
	// The previous screen is the office screen
	$scope.prev = function()
	{
		manager.transition('level1_learn');
	};
	
}]);